<template functional>
  <footer class="footer">
    <div class="footer-left">
        <img
          src="../../assets/svmic-logo-white.png"
          class="footer-left__logo"
          alt="SVMIC Logo"
        />
        <p class="footer-left__copyright">
          <a href="https://www.svmic.com/privacy-policy"
             target="_blank">
            Privacy Policy
          </a>
          &nbsp;|&nbsp;Copyright&nbsp;©&nbsp;2024 SVMIC
        </p>
      </div>
      <div class="footer-right">
        <p>
          In order to best serve all of our policyholders, SVMIC is committed to
          accessibility of our website. If you experience issues, please contact us
          at <a href="tel:8003422239">(800) 342-2239</a>.
        </p>
      </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
};
</script>>
